import React from 'react';

function FacebookSquareIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.9,0C1.3,0,0,1.3,0,2.9v14.3C0,18.7,1.3,20,2.9,20h4.4v-6.5H4.9V10h2.4V8.5c0-3.9,1.8-5.7,5.6-5.7c0.7,0,2,0.1,2.5,0.3v3.2c-0.3,0-0.7,0-1.3,0c-1.9,0-2.6,0.7-2.6,2.6V10h3.7l-0.6,3.5h-3.1V20h5.8c1.6,0,2.9-1.3,2.9-2.9V2.9C20,1.3,18.7,0,17.1,0H2.9z" />
    </svg>
  );
}

export default FacebookSquareIcon;
